import { createContext } from 'react';
import type { InvalidFields } from 'state/selectors/meta/static/utils';

const empty = {
  errors: [],
  warnings: [],
};

export const InvalidFieldsContext = createContext<InvalidFields>(empty);
